<div class="input-wrapper d-inline-block">
	<div class="form-check form-check-inline">
		<input type="radio" class="form-check-input" [id]="id" [formControl]="control" [value]="value" [name]="name">
		<label class="form-check-label" [for]="id">
			{{label}}
		</label>
	</div>
</div>